import { render } from "./additional-deductions.vue?vue&type=template&id=bb22e6ca&scoped=true"
import script from "./additional-deductions.vue?vue&type=script&lang=js"
export * from "./additional-deductions.vue?vue&type=script&lang=js"

import "./additional-deductions.vue?vue&type=style&index=0&id=bb22e6ca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb22e6ca"]])

export default __exports__